import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { AuditVisitRepReviewDetail } from '../types';

export const getAuditorVisitRepReviewById = async (
  id: string
): Promise<AuditVisitRepReviewDetail> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/audit-visit-rep-review/${id}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditVisitRepReviewDetail;
  return response;
};
